import React from 'react';
import useTranslate from 'Hooks/useTranslate';
import { Title } from 'SharedComponents/styled/overlay/Title';

interface OverlayTitleProps {
    headlineText: string | string[];
}

const Headline: React.FunctionComponent<{ from: string | string[] | React.ReactHTMLElement<HTMLElement> }> = ({
    from,
}) => (
    <>
        {!Array.isArray(from)
            ? from
            : from.map((textLine, index) => (
                  <React.Fragment key={textLine.concat(index.toString())}>
                      {index !== 0 && <br />}
                      {textLine}
                  </React.Fragment>
              ))}
    </>
);

const OverlayTitle: React.FunctionComponent<OverlayTitleProps> = ({ headlineText }) => {
    const { t } = useTranslate();
    const defaultRegisterHeadline = t('signupOverlay_Registration title');
    const className = 'qa-signup-overlay__title';
    const titleText = headlineText || defaultRegisterHeadline;

    return (
        <Title isCustomized={!!headlineText} className={className} isWide={false}>
            <Headline from={titleText} />
        </Title>
    );
};

export default OverlayTitle;
